type Props = {
  size?: "sm" | "md";
};

export function Spinner({ size = "md" }: Props) {
  return (
    <span
      className={`spinner${size === "sm" ? " spinner--sm" : ""}`}
      role="status"
      aria-label="Loading"
    />
  );
}
